import React from "react";
import "../Terms&Conditions/TermsAndConditions.css";

export const RefundCancellationPolicy = () => {
  return (
    <div className="container">
      <div className="termsHeader mt-3">
        <h2>Refund & Cancellation Policy </h2>
        <p>
          <b> Effective Date: 1-Oct-2025 </b>
        </p>
      </div>
      <div className="termsContainer">
        <div className="terms-list-content">
          <div className="list-header">Training Programs </div>
          <div className="terms-content">
            <p>Cancel 7+ days before start → 50% refund. </p>
            <p>Cancel 7 days before start → No refund. </p>
            <p>Once course begins → Non-refundable.</p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header"> Listening Sessions </div>
          <div className="terms-content">
            <p>Cancel 24+ hrs in advance → Full refund or reschedule.</p>
            <p>Cancel 24 hrs in advance → No refund. </p>
            <p>Listener no-show → Reschedule at no extra cost. </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Processing</div>
          <div className="terms-content">
            <p>
              Refunds processed within 7–10 working days or as per the banking
              norms.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
